export const TABS_VEHICLE_UPDATE = {
    VEHICLE_DETAILS: {
        INDEX: 0,
        TRANS: "details",
    },
    PHOTO: {
        INDEX: 1,
        TRANS: "photo",
    },
}
export const TABS_VEHICLE_CREATE = {
    DETAILS: {
        INDEX: 0,
        TRANS: "details",
    },
    PHOTO: {
        INDEX: 1,
        TRANS: "upload_photo",
    },
    SUMMARY: {
        INDEX: 2,
        TRANS: "summary",
    },
}